import script from "./BulkPricingExplained.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkPricingExplained.vue?vue&type=script&setup=true&lang=js"

import "./BulkPricingExplained.vue?vue&type=style&index=0&id=34009dd7&scoped=true&lang=css"
import "./BulkPricingExplained.vue?vue&type=style&index=1&id=34009dd7&lang=css"

import exportComponent from "/Users/darrenlumber/Sites/office-drop-craft/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34009dd7"]])

export default __exports__